import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Container, Typography, Box, Divider, Tabs, Tab } from '@mui/material';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import RefundCancellationPolicy from './RefundCancellationPolicy';

const LegalCenter = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const RedirectToPreviousPage = () => navigate(-1);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container
      maxWidth='md'
      sx={{
        marginTop: '20px',
        lineHeight: 1.3,
      }}
    >
      {/* Page Title */}
      <button style={{ marginBottom: '10px', cursor: 'pointer' }} onClick={RedirectToPreviousPage}>
        Close X{' '}
      </button>
      <Typography
        variant='h4'
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: '#181436',
          fontSize: { xs: '1.8rem', md: '2.5rem' },
        }}
      >
        Legal Center
      </Typography>
      {/* <Typography variant="body2" color="text.secondary" gutterBottom>
                Effective Date: August 2, 2025
            </Typography> */}

      <Divider sx={{ my: { xs: 2, md: 3 } }} />

      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        textColor='primary'
        indicatorColor='primary'
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: { xs: 2, md: 3 },
        }}
      >
        <Tab label='Terms & Conditions' />
        <Tab label='Privacy Policy' />
        <Tab label='Refund & Cancellation' />
      </Tabs>

      {/* Tab Content */}
      {activeTab === 0 && <TermsOfService />}
      {activeTab === 1 && <PrivacyPolicy />}
      {activeTab === 2 && <RefundCancellationPolicy />}
    </Container>
  );
};

export default LegalCenter;
